

// 1. Trigger change event on has-account radio
const selected = document.querySelector('input[name="has-account"]:checked');
if (selected) selected.dispatchEvent(new Event('change'));

// 2. Auto-check product checkbox when input is focused
const wrapper = document.getElementById("product-wrapper");

if (wrapper) {
  wrapper.addEventListener("focusin", (e) => {
    const isRelevantField = e.target.matches("select") || e.target.matches("input[type='number']");

    if (!isRelevantField) return;

    const productBlock = e.target.closest(".product-card");
    const checkbox = productBlock?.querySelector(".product-option");

    // Only check if it's not already selected or disabled
    if (checkbox && !checkbox.checked && !checkbox.disabled) {
      checkbox.checked = true;
    }
  });
}

// const productCards = document.querySelectorAll(`input[class="product-option"]`);
const productCards = document.querySelectorAll(`.product-card`);
let cards = {};

function disableProductCard(productName, disableCheck, checked) {
  const card = cards[productName].querySelector(`input[class="product-option"]`)
  card.disabled = disableCheck;
  card.checked = checked;
}

// if quantity boxes are not empty you cannot unclick a product 
//case when only one product and want to delete

//case when more than one 
//check is disabled 

productCards.forEach(card => {
  const productName = card.dataset.product.toLowerCase();
  cards[productName] = card;

  const productSelection = card.querySelector(`input[class="product-option"]`);
  const quantityField = card.querySelector('input[type="number"]');

  //event listener for product checkbox 
  productSelection.addEventListener("change", () => {
    //const productName = card.value;
    //true if product is selected
    // if quantity option >1 checkbox is disable
    const containerCount = card.querySelectorAll('.quantity_container').length;
      if (containerCount === 1) {
        productSelection.disabled = false;
        return;
      }

    const selected = productSelection.checked;
    productSelection.disabled = selected;
    quantityField.required = selected;
  });
})


//Field toggle handler

function setupRadioToggle({ radioName, targetSelectors, toggleRules }) {
  const radios = document.querySelectorAll(`input[name="${radioName}"]`);
  radios.forEach(radio => {
    radio.addEventListener('change', () => {
      const value = radio.value;

      toggleRules.forEach(rule => {
        const target = document.querySelector(rule.selector);
        if (!target) return;

        if (rule.type === 'toggleClass') {
          target.classList.toggle(rule.className, !rule.condition(value));
        }

        if (rule.type === 'disable') {
          target.disabled = !rule.condition(value);
        }
      });
    });
  });
}

// 1. Toggle account fieldsets
setupRadioToggle({
  radioName: 'has-account',
  toggleRules: [
    {
      selector: '#has_account_fieldset',
      type: 'toggleClass',
      className: 'hidden',
      condition: val => val === 'yes'
    },
    {
      selector: '#has_account_fieldset',
      type: 'disable',
      condition: val => val === 'yes'
    },
    {
      selector: '#no_account_fieldset',
      type: 'toggleClass',
      className: 'hidden',
      condition: val => val === 'no'
    },
    {
      selector: '#no_account_fieldset',
      type: 'disable',
      condition: val => val === 'no'
    }
  ]
});

// 2. Disable shipping address if same
setupRadioToggle({
  radioName: 'same-address',
  toggleRules: [
    {
      selector: '#shipping-address',
      type: 'disable',
      condition: val => val === 'no'
    }
  ]
});

// 3. Disable provider email if same
setupRadioToggle({
  radioName: 'provider-agreement-email',
  toggleRules: [
    {
      selector: '#provider-email',
      type: 'disable',
      condition: val => !val.toLowerCase().includes('yes')
    }
  ]
});

//Product selection functions
function showWarning(warningID) {
  try {
    const warning = document.getElementById(warningID);
    //warning.textContent = message;
    warning.classList.remove("hidden");
    setTimeout(() => {
      warning.classList.add("hidden");
    }, 3000);
  } catch (e) {
    return;
  }
  ;

}


function addQuantityField(button, warningId) {
  // Find the product card container
  const productCard = button.closest('.product-card');
  const productName = productCard.getAttribute('data-product');
  const productId = productCard.getAttribute('data-product-id');

  // Find the fieldset that contains all quantity containers
  const fieldset = productCard.querySelector(`#quantity_${productId}`);

  // Get all existing quantity containers to determine the next ID number
  const existingContainers = fieldset.querySelectorAll('.quantity_container');
  const lastContainer = existingContainers[existingContainers.length - 1];

  // Check if the last container has both size and quantity filled
  const lastSize = lastContainer.querySelector('select');
  const lastQuantity = lastContainer.querySelector('input[type="number"]');

  if (!lastSize.value || !lastQuantity.value || lastQuantity.value <= 0) {
    // Show warning message
    const warningDiv = document.getElementById(warningId);
    console.log(warningDiv);
    warningDiv.classList.add('visible');
    lastQuantity.classList.add('error');
    lastSize.classList.add('error');



    // Hide warning after 3 seconds
    setTimeout(() => {
      lastQuantity.classList.remove('error');
      lastSize.classList.remove('error');
      warningDiv.classList.remove('visible');
    }, 3000);

    return; // Don't add new field
  }

  // Hide any existing warning
  lastQuantity.classList.remove('error');
  lastSize.classList.remove('error');
  const warningDiv = document.getElementById(warningId);
  warningDiv.classList.remove('visible');

  // Get the next ID number
  const currentIdNum = parseInt(lastContainer.getAttribute('data-id-num'));
  const newIdNum = currentIdNum + 1;

  // Clone the last quantity container
  const newContainer = lastContainer.cloneNode(true);

  // Update the data-id-num attribute
  newContainer.setAttribute('data-id-num', newIdNum);

  // Clear the values in the cloned container
  const newSelect = newContainer.querySelector('select');
  const newInput = newContainer.querySelector('input[type="number"]');

  newSelect.selectedIndex = 0;
  newInput.value = '';

  // // Update the name attributes to be unique
  // newSelect.setAttribute('name', `${productName}_size_${newIdNum}`);
  // newInput.setAttribute('name', `${productName}_quantity_${newIdNum}`);

  // Add the new container to the fieldset
  fieldset.appendChild(newContainer);

  // Focus on the new size select for better UX
  newSelect.focus();
}

function removeQuantityField(button, event) {
  event.preventDefault();

  // Find the quantity container to remove
  const container = button.closest('.quantity_container');
  const fieldset = container.closest('fieldset');
  const productName = container.dataset.product.toLowerCase();


  // Don't allow removal if it's the only container
  const allContainers = fieldset.querySelectorAll('.quantity_container');
  //const blocksCount = orderFields[productName];
  if (allContainers.length <= 1) {
    container.querySelector("input[type='number']").value = '';
    disableProductCard(productName, false, false);
    return;
  }

  // Remove the container
  container.remove();
  orderFields[productName] -= 1;
  const newCount = orderFields[productName];

  if (newCount === 1) {
    // Only one block left now — enable checkbox but keep it checked
    disableProductCard(productName, false, true);
  }
}



//form submission event 
function collectOrderData() {
  const products = [];

  // Loop through all checked product checkboxes
  document.querySelectorAll('.product-option:checked').forEach(checkbox => {
    const card = checkbox.closest('.product-card');
    const productName = checkbox.value.toUpperCase();

    const selections = [];

    card.querySelectorAll('.quantity_container').forEach(container => {
      const size = container.querySelector('select').value;
      const quantity = container.querySelector('input[type="number"]').value;

      // Only push if there's a valid quantity
      if (quantity && parseInt(quantity, 10) > 0) {
        selections.push({ size, quantity });
      }
    });

    if (selections.length > 0) {
      products.push({
        product: productName,
        selections: selections
      });
    }
  });

  return products;
}


document.getElementById("contactForm").addEventListener("submit", function (e) {
  e.preventDefault(); // Prevent form submission

  const form = e.target;
  const orderInput = document.getElementById("orderField");

  const order = collectOrderData(); // Assuming this returns an array
  orderInput.value = JSON.stringify(order);

  const formData = new FormData(form);

  const summaryEl = document.getElementById("order-summary");
  summaryEl.innerHTML = ""; // Clear previous summary

  // Build readable summary from FormData
  for (let [key, value] of formData.entries()) {
    if (key === 'order') {
      try {
        const parsedOrder = JSON.parse(value);
        const orderResponse = parsedOrder.map(order => {
          const quantities = order.selections.map(sel => `• ${sel.quantity} × ${sel.size}`).join(`<br>`);
          return `<strong>${order.product}</strong><br>${quantities}`;
        }).join('<br><br>');

        const div = document.createElement('div');
        div.innerHTML = `<br><h2> Products: </h2>${orderResponse}`;
        summaryEl.appendChild(div);

      } catch (err) {
        summaryEl.textContent += "Order: Invalid order data\n";
      }
    } else {
      const field = form.querySelector(`[name="${key}"]`);
      if (field?.type === "hidden") continue;

      const label = field?.dataset.label || key;

      const div = document.createElement('div');
      div.innerHTML = `<strong>${label}:</strong> `;
      const span = document.createElement('span');
      span.textContent = value;  // safe escaping for user text
      div.appendChild(span);
      summaryEl.appendChild(div);
    }
  }

  // Build a map of fieldName -> data-label
  const labelsMap = {};
  for (const el of Array.from(form.elements)) {
    if (el.name && el.dataset && el.dataset.label) {
      labelsMap[el.name] = el.dataset.label;
    }
  }

  // Upsert a hidden input to carry the labels JSON
  let labelsInput = form.querySelector('input[name="__labels__"]');
  if (!labelsInput) {
    labelsInput = document.createElement('input');
    labelsInput.type = 'hidden';
    labelsInput.name = '__labels__';
    form.appendChild(labelsInput);
  }
  labelsInput.value = JSON.stringify(labelsMap);

  // Show modal
  const modal = document.getElementById("confirmation-modal")
  modal.style.display = "flex";

  const confirmBtn = document.getElementById("confirm-submit");
  const cancelBtn  = document.getElementById("cancel-confirm");
  const loadingBtn = document.getElementById("submit-loading");
  const iframe     = document.getElementById("hidden_iframe");
  const successEl  = document.getElementById("success-message");

  // Ensure form targets the hidden iframe (in case you didn’t set it in HTML)
  form.setAttribute('target', 'hidden_iframe');

  // Clean previous load handlers and set a one-time handler
  iframe.onload = () => {
    if (loadingBtn) loadingBtn.style.display = "none";
    confirmBtn.disabled = false;
    cancelBtn.disabled = false;

    modal.style.display = "none";
    successEl.classList.remove("hidden");
    successEl.classList.add("visible");

    // Optional: reset form & summary after successful submit
    form.reset();
    summaryEl.innerHTML = "";
  };

  confirmBtn.onclick = async () => {
    confirmBtn.disabled = true;
    cancelBtn.disabled = true;
    // Submit to Apps Script; page stays put because of target=hidden_iframe
    if (loadingBtn) loadingBtn.style.display = "inline-flex";
    await new Promise(resolve => grecaptcha.ready(resolve));
    const token = await grecaptcha.execute('6Ld5iq8sAAAAACVO1Z3aeRIS4iC4ywraOudS59iC', { action: 'order' });
    document.getElementById('recaptchaToken').value = token;

    form.submit();
  };

  cancelBtn.onclick = () => {
    modal.style.display = "none";
    // Just in case user cancels after showing loader in some flow:
    if (loadingBtn) loadingBtn.style.display = "none";
    confirmBtn.disabled = false;
    cancelBtn.disabled  = false;
  };
});
